export const OrderPartFormsEnum = {
    ORDER_PART_FORM: 'ORDER_PART_FORM',
    ADD_CAR_FORM: 'ADD_CAR_FORM'
};